import React from 'react'
import toast from 'react-hot-toast'

import { ConnectedConnectionNotification, ConnectedDisconnectionNotification } from "./ConnectionNotifications"


export const
  notifyConnected = (key, device) => toast.success(<ConnectedConnectionNotification deviceKey={ key } device={ device } />),
  notifyDisconnected = (key, device) => toast.error(<ConnectedDisconnectionNotification deviceKey={ key } device={ device } />)
